export default [
  {
    id: "1",
    discountID: "0",
    price: "4000",
    created_at: "۱۸:۴۱:۴۴ ۱۴۰۱/۰۶/۲۸",
  },
  {
    id: "2",
    discountID: "0",
    price: "3000",
    created_at: "۱۸:۵۱:۴۴ ۱۴۰۱/۰۶/۲۸",
  },
  {
    id: "3",
    discountID: "0",
    price: "2400",
    created_at: "۱۹:۰۲:۴۴ ۱۴۰۱/۰۶/۲۸",
  },
  {
    id: "4",
    discountID: "0",
    price: "4700",
    created_at: "۱۹:۲۶:۴۴ ۱۴۰۱/۰۶/۲۸",
  },
  {
    id: "5",
    discountID: "0",
    price: "40000",
    created_at: "۱۸:۴۱:۴۴ ۱۴۰۱/۰۶/۲۸",
  },
  {
    id: "6",
    discountID: "0",
    price: "40000",
    created_at: "۱۸:۴۱:۴۴ ۱۴۰۱/۰۶/۲۸",
  },
];
